import React from 'react';

interface IIconCheckMarkProps {
	className?: string;
}

const IconCheckMark = ({ className }: IIconCheckMarkProps) => {
	return (
		<>
			<svg
				className={`hidden sm:block ${className || ''}`}
				width='28'
				height='27'
				viewBox='0 0 28 27'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path
					d='M13.9122 0.364258C6.65795 0.364258 0.776367 6.24584 0.776367 13.5001C0.776367 20.7544 6.65795 26.636 13.9122 26.636C21.1665 26.636 27.0481 20.7544 27.0481 13.5001C27.0481 6.24584 21.1665 0.364258 13.9122 0.364258ZM18.8382 7.90753L21.1468 10.2162L12.2702 19.0927L6.67765 13.5001L8.98628 11.1915L12.2702 14.4755L18.8382 7.90753Z'
					fill='#06CB84'
				/>
			</svg>
			<svg
				className={`sm:hidden ${className || ''}`}
				width='19'
				height='19'
				viewBox='0 0 19 19'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path
					d='M9.5 0C4.25362 0 0 4.25362 0 9.5C0 14.7464 4.25362 19 9.5 19C14.7464 19 19 14.7464 19 9.5C19 4.25362 14.7464 0 9.5 0ZM13.0625 5.45537L14.7321 7.125L8.3125 13.5446L4.26788 9.5L5.9375 7.83037L8.3125 10.2054L13.0625 5.45537Z'
					fill='#06CB84'
				/>
			</svg>
		</>
	);
};

export default IconCheckMark;
